import React from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { changeOriginAirport } from "../searchFlightsSlice";
import AirportInput from "./AirportInput";
import { faPlaneDeparture } from "@fortawesome/free-solid-svg-icons/faPlaneDeparture";
import { useTranslation } from "react-i18next";
function OriginAirportInput() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const originAirport = useAppSelector(
    (state) => state.searchFlights.form.originAirport
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const validity: boolean = useAppSelector(
    (state) => state.searchFlights.formValidity.originAirport
  );
  const destinationAirport = useAppSelector((state) => state.searchFlights.form.destinationAirport);
  const allowSameDestination = useAppSelector((state) => state.config.mapper.allowSameDestination);
  const onSelect = (suggestion) => {
    if (!allowSameDestination && suggestion.port.code === destinationAirport?.port.code) {
      dispatch(changeOriginAirport(null));
      return;
    }
    dispatch(changeOriginAirport(suggestion));
  };

  return (
    <AirportInput
      id="origin-airport-input"
      airport={originAirport}
      validity={validity}
      validityMessage={t("SEARCH_ALERT_ORIGIN_AIRPORT")}
      icon={faPlaneDeparture}
      label={t("INPUT_LABEL_FROM")}
      placeholder={`${t("INPUT_SELECT_DEPARTURE_AIRPORT")}`}
      title={t("ORIGIN_SEARCH_TITLE")}
      onSelect={onSelect}
      disabled={originAirport?.readOnly || disabled}
      {...(!allowSameDestination && { excludeAirport: destinationAirport })}
  />
  );
}

export default OriginAirportInput;
